module.exports = __webpack_public_path__ + "static/media/eth.2a872dee.svg";